// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--HJ3wc","body":"body--3g_qD","bodyContent":"bodyContent--3U4yU","emailContainer":"emailContainer--vJgC6","alert":"alert--GCW0u"};